import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {addSubField} from "../../../../../store/actions/subFields";
import {changeGroupField} from "../../../../../store/actions/groupFields";
import {connect} from "react-redux";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";

const TaxonomiesFilter = (props) => {

	const {addSubField, group, changeGroupField} = props;

	const newTaxonomy = {
		name: 'term',
		label: 'Term',
		fields: [
			getFieldFactory().getSourceField(),
			getFieldFactory().getValueInputType(),
			{
				id: 'taxonomy',
				inputType: 'select',
				source: 'taxonomies',
				sourceName: 'name',
				sourceValue: 'value',
				value: '',
				label: 'Taxonomy',
				defaultValue: 'Select a taxonomy',
				dynamic: false
			},
			{
				id: 'field-type',
				inputType: 'select',
				source: 'termFieldTypes',
				sourceName: 'name',
				sourceValue: 'value',
				value: '',
				label: 'Field type',
				defaultValue: 'Select a field type',
				dynamic: false
			},
			{
				id:           'queryGroup',
				inputType:    'select',
				source:       'queryGroups',
				sourceName:   'name',
				sourceValue:  'name',
				value:        '',
				label:        'Query Group',
				defaultValue: 'Select a group',
				dynamic:      false
			},
			getFieldFactory().getParametersField(),
			getFieldFactory().getDynamicField()
		],
	};

	return (
		<React.Fragment>

			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (<React.Fragment>
					<h3>Taxonomies ({endpoint.displayData[currentItem].taxonomies.length})</h3>

					<p>Use this section for adding one or more custom taxonomy filters for your endpoint. You can set a fixed value or choose an already defined parameter.</p>

					<p>If you need to group some conditions, you should create a Query Group and then connect your terms.</p>

					<ParametersNotice parameters={endpoint.parameters}/>

					<label>Main relation type:</label>
					<select className="restroutes-select-small" value={endpoint.displayData[currentItem].taxonomyRelationType} onChange={ e => changeGroupField( endpointId, 'displayData', currentItem, 'taxonomyRelationType', e.target.value )}>
						<option value="AND">AND</option>
						<option value="OR">OR</option>
					</select>

					<button onClick={() => addSubField(endpointId, [ newTaxonomy ], currentItem, group, action)} className="button-secondary">
						Add term filter
					</button>

					<FieldGroups group={group}/>

				</React.Fragment>)}
			</FieldGroupContext.Consumer>
		</React.Fragment>
	);
};

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
	changeGroupField: ( endpointId, group, index, field, value ) => dispatch( changeGroupField( endpointId, group, index, field, value ) )
});

export default connect( mapStateToProps, mapDispatchToProps )(TaxonomiesFilter);
